import browserUpdate from 'browser-update';
import objectFitImages from 'object-fit-images';

// Using our own copy of focus-within polyfill because the
// original one doesn't come pre-complied
// https://github.com/jonathantneal/focus-within
import focusWithin from './js/polyfills/focus-within';
import MobileNav from './js/mobile-nav';
import MobileNavToggles from './js/mobile-nav-toggles';

import './js/polyfills';
import './js/primary-nav';
import './js/detect-browser';
import './js/element-carousel';
import './scss/styles.scss';

const init = () => {
  browserUpdate();
  objectFitImages();
  focusWithin(document, { force: true });
  MobileNav.init();
  MobileNavToggles.init();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
